/* eslint-disable sort-keys-fix/sort-keys-fix */
import {
  type DataRoomsListQuery,
  type DraftDataRoom,
  type PublishedDataRoom,
} from "@decentriq/graphql/dist/types";
import { faTable, faTableRows } from "@fortawesome/pro-regular-svg-icons";

export type DataRoomsListItem =
  DataRoomsListQuery["dataRooms"]["nodes"][number];

export interface DataRoomListFilter {
  key: "all" | "hidden" | "favourites" | "stopped" | "sharedWithMe" | "active";
  field: string | null;
  value?: string | boolean | null;
  label: string;
  equalsTo?: (
    dataRoom: Partial<DraftDataRoom | PublishedDataRoom>,
    payload: any
  ) => boolean;
}

export enum SelectedView {
  Card = "card",
  Table = "table",
}

export const selectedViewIconsPresentation = {
  [SelectedView.Table]: faTableRows,
  [SelectedView.Card]: faTable,
};

// An item will be filtered out only field's value === value defined in the object
export const filterOptionsMap: Record<string, DataRoomListFilter> = {
  active: {
    equalsTo: ({ userSettings, isStopped = false, deactivatedAt = null }) =>
      !(userSettings?.isArchived || isStopped || deactivatedAt),
    field: null,
    key: "active",
    label: "Active",
  },
  sharedWithMe: {
    equalsTo: (dataRoom, currentUserEmail) =>
      dataRoom?.owner?.email !== currentUserEmail,
    field: "owner.email",
    key: "sharedWithMe",
    label: "Shared with me",
  },
  favourites: {
    field: "userSettings.isFavorite",
    key: "favourites",
    label: "Favourites",
    value: true,
  },
  hidden: {
    field: "userSettings.isArchived",
    key: "hidden",
    label: "Hidden",
    value: true,
  },
  stopped: {
    field: "isStopped",
    key: "stopped",
    label: "Stopped",
    value: true,
  },
  all: {
    field: null,
    key: "all",
    label: "All",
    value: null,
  },
};

export const filterOptions = Object.values(filterOptionsMap);
